import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsTimeslotKindLimitation from 'graphql/fields/FieldsTimeslotKindLimitation'

const fields = {
	'timeslot_kind_guid': 'String!',
	'car_type': '[String]',
	'car_fuel_type': '[String]',
	
	'car_length_max': 'Float',
	'car_width_max': 'Float',
	'car_height_max': 'Float',
	'car_wheelbase_max': 'Float',
	'car_weight_max': 'Float',
};

export default gql(`
	mutation timeslot_kind_limitation( ${ HelperGraphql.createFields( fields ) } ) {
	    timeslot_kind_limitation( ${ HelperGraphql.createVariables( fields ) } ) {
	       ${FieldsTimeslotKindLimitation}
	    }
	}
`);

